import { jwtDecode } from "jwt-decode";

// Lee el rol del JWT guardado. Devuelve null si no hay token o es inválido.
export const getRolActual = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    return jwtDecode(token)["rol"] || null;
  } catch {
    return null;
  }
};

// Ruta de inicio según rol. El suscriptor va a su bandeja; el resto al home.
export const getHomePorRol = (rol) =>
  rol === "Suscriptor" ? "/suscriptor/bandeja" : "/home";